var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6462 6.13C13.4382 6.13 14.0502 6.688 14.0502 7.426C14.0502 8.2 13.4202 8.722 12.6462 8.722C11.8722 8.722 11.2782 8.128 11.2782 7.426C11.2782 6.724 11.8722 6.13 12.6462 6.13ZM13.7442 10.36V19H11.5842V10.36H13.7442Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.832 0 0 5.832 0 13C0 20.168 5.832 26 13 26C20.168 26 26 20.168 26 13C26 5.832 20.168 0 13 0ZM13 2C19.087 2 24 6.913 24 13C24 19.087 19.087 24 13 24C6.913 24 2 19.087 2 13C2 6.913 6.913 2 13 2Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconI);
export default __webpack_public_path__ + "static/media/info-icon-i.cd162981a739a1abd5d99b2aad0f868a.svg";
export { ForwardRef as ReactComponent };